module.exports = __webpack_public_path__ + "static/footbed-f68dc6a1448a9175c8ed2f155b20781a.png";